// Curadoria de sugestões de IA (spec-003/005/006). Vive em arquivo PRÓPRIO —
// `Text.js` estourou o teto de 500 linhas com a chegada do [T021] (spec-007);
// este bloco é o maior contíguo e domain-coeso, então saiu primeiro. Mesmo
// padrão de `MEMORIA_TEXT`/`Text.memoria.js`: `Text.js` reexporta tudo daqui,
// então `import { CURADORIA_TEXT } from '@modules/aawz-intelligence-v2/
// constants/Text'` continua funcionando sem mudar nenhum importador.

// Rótulo por tipo do enum aawz_intelligence_suggestions.
export const CURADORIA_TIPO_LABEL = {
  operacional: 'Tarefa',
  relacionamento: 'Oportunidade',
  evento_de_vida: 'Evento de vida',
  dado_de_vida: 'Dado de vida',
  objetivo: 'Objetivo',
  contexto: 'Contexto',
  // spec-002 (aawz-web-backend#1494): a IA corrige o CADASTRO de um ativo do cliente
  // (`app_dados_ativos_clientes`). Sem a chave, o card mostrava o slug `correcao_cadastro`
  // cru como rótulo E como título, nas duas telas que leem esta fila.
  correcao_cadastro: 'Correção de cadastro',
}

// Ícone por tipo no chip do card (BaseStatus não-soft) — todos na cor primary.
export const CURADORIA_TIPO_ICON = {
  operacional: 'task-square',
  relacionamento: 'lamp-on',
  evento_de_vida: 'calendar-check',
  dado_de_vida: 'hearts',
  objetivo: 'mdi-target',
  contexto: 'menu-board',
  correcao_cadastro: 'edit-2',
}

export const CURADORIA_RESPONSAVEL_LABEL = {
  assessor: 'Assessor',
  equipe: 'Equipe',
  cliente: 'Cliente',
  automatizavel: 'Automatizável',
}

export const CURADORIA_TEXT = {
  pageTitle: 'Sugestões a triar',
  pageDescription:
    'Tudo o que a IA propôs a partir das reuniões espera aqui. Revise, edite se precisar, e aceite ou descarte. Nada vira registro sem a sua curadoria.',
  noData: 'Nada a triar',
  noDataDescription:
    'Quando a IA propuser algo a partir de uma reunião, aparece aqui.',
  semCliente: 'Sem cliente',
  confianca: 'confiança',
  origem: 'Trecho da reunião',
  // spec-005: o racional é o "por que" da IA. Sem ele (sugestões anteriores ao campo),
  // o card mostra só o trecho — sem bloco vazio.
  racionalToggle: 'Por que a IA sugeriu isso',
  accept: 'Aceitar',
  // O botão leva ao modal de edição, mas salvar ali JÁ aceita a sugestão com os
  // dados editados (não é um passo "só editar" separado) — o rótulo deixa isso
  // explícito em vez do usuário descobrir só depois de clicar.
  edit: 'Editar e aceitar',
  decline: 'Descartar',
  // suggestion-summary-card.vue (painel de Transcrições) usa rótulos próprios —
  // "Aprovar"/"Recusar" — em vez de "Aceitar"/"Descartar" (mesma ação, cópia
  // adaptada ao contexto do card vertical do modal).
  aprovar: 'Aprovar',
  recusar: 'Recusar',
  acceptClient: 'Aceitar tudo do cliente',
  acceptSelected: 'Aceitar selecionadas',
  acceptAll: 'Aceitar tudo',
  // Confirmações
  confirmTitle: 'Aceitar sugestões',
  confirmAcceptAll:
    'Aceitar todas as sugestões pendentes? As entidades reais serão criadas.',
  confirmAcceptClient: (nome) =>
    `Aceitar todas as sugestões de ${nome}? As entidades reais serão criadas.`,
  confirmAcceptSelected: (n) =>
    `Aceitar ${n} ${
      n === 1 ? 'sugestão selecionada' : 'sugestões selecionadas'
    }?`,
  confirmBtn: 'Aceitar',
  cancel: 'Cancelar',
  declineTitle: 'Descartar sugestão',
  declineText: 'Descartar esta sugestão? Ela não vira registro e some da fila.',
  declineBtn: 'Descartar',
  // Feedback
  acceptedOne: 'Sugestão aceita',
  declinedOne: 'Sugestão descartada',
  acceptedMany: (n) =>
    `${n} ${n === 1 ? 'sugestão aceita' : 'sugestões aceitas'}`,
  someFailed: (n) =>
    n === 1
      ? '1 sugestão não pôde ser criada. Revise e tente de novo'
      : `${n} sugestões não puderam ser criadas. Revise e tente de novo`,
  // Modal de edição
  editTitle: 'Editar sugestão',
  save: 'Salvar e aceitar',
}

// spec-006 — mesa de triagem: KPIs, progresso, abas, filtros e restauração.
export const CURADORIA_TRIAGEM = {
  // KPIs
  kpiATriar: 'A triar',
  kpiATriarDesc: 'sugestões aguardando decisão',
  kpiAlta: 'Alta confiança',
  kpiAltaDesc: '90% ou mais, seguras para lote',
  kpiRevisar: 'Revisar com atenção',
  kpiRevisarDesc: 'abaixo de 70% de confiança',
  kpiClientes: 'Clientes impactados',
  kpiClientesDesc: 'com sugestões na fila',
  // Progresso
  progressoTitulo: 'Progresso da triagem',
  progressoContagem: (decididas, total) => `${decididas} de ${total} decididas`,
  // Abas
  abaATriar: 'A triar',
  abaAceitas: 'Aceitas',
  abaDescartadas: 'Descartadas',
  // Filtros
  buscar: 'Buscar',
  buscarPlaceholder: 'Cliente, título...',
  confianca: 'Confiança',
  origem: 'Origem',
  ordenar: 'Ordenar por',
  todos: 'Todos',
  todosTipos: 'Todos os tipos',
  limparFiltros: 'Limpar filtros',
  // Lote de alta confiança
  aceitarAlta: (n) => `Aceitar alta confiança (${n})`,
  confirmAceitarAlta: (n) =>
    `Aceitar ${n} ${
      n === 1 ? 'sugestão' : 'sugestões'
    } com 90% ou mais de confiança? As entidades reais serão criadas.`,
  // Descarte com motivo (R18) — o motivo é o sinal que ensina a IA
  descarteExplicacao:
    'A sugestão sai da fila e não vira registro. Se disser por que, a IA aprende a não propor de novo.',
  motivoLabel: 'Motivo (opcional)',
  motivoPlaceholder: 'Ex.: o cliente já tem isso registrado',
  motivosRapidos: [
    'Não faz sentido',
    'Já existe',
    'Informação errada',
    'Não é prioridade',
  ],
  // Lote
  selecionarTodasCliente: 'Selecionar todas',
  descartarSelecionadas: 'Descartar selecionadas',
  descartarCliente: 'Descartar todas do cliente',
  confirmDescartarLote: (n) =>
    `Descartar ${n} ${
      n === 1 ? 'sugestão' : 'sugestões'
    }? Elas saem da fila sem virar registro.`,
  descartadasMuitas: (n) =>
    `${n} ${n === 1 ? 'sugestão descartada' : 'sugestões descartadas'}`,
  // Navegação (R4) — o caminho inverso do alerta da spec-005
  irParaTranscricoes: 'Ir para Transcrições',
  // Origem do card (R14)
  reuniaoPrefixo: 'Reunião:',
  prazoPrefixo: 'Prazo:',
  valorPrefixo: 'Valor:',
  // Restaurar (o "desfazer" do descarte)
  restaurar: 'Restaurar',
  restaurarTooltip: 'Devolver para a fila',
  restaurada: 'Sugestão devolvida para a fila',
  // Empty states por aba
  vazioATriar: 'Nada a triar: a fila está limpa.',
  vazioAceitas: 'Nenhuma sugestão aceita ainda.',
  vazioDescartadas: 'Nada descartado.',
  vazioFiltro: 'Nenhuma sugestão com esses filtros.',
}

// Faixas de confiança — rótulo + o que fazer em cada uma (tooltip).
export const CURADORIA_CONFIANCA_LABEL = {
  alta: 'alta',
  media: 'média',
  baixa: 'baixa',
}
export const CURADORIA_CONFIANCA_TOOLTIP = {
  alta: 'Seguro para aceitar em lote',
  media: 'Confira o trecho antes de aceitar',
  baixa: 'Revise com atenção: a IA teve pouca evidência',
}

export const CURADORIA_CONFIANCA_OPTIONS = [
  { text: 'Alta (90%+)', value: 'alta' },
  { text: 'Média (70-89%)', value: 'media' },
  { text: 'Baixa (<70%)', value: 'baixa' },
]

export const CURADORIA_ORDENACAO_OPTIONS = [
  { text: 'Maior confiança', value: 'confianca' },
  { text: 'Mais recente', value: 'recente' },
  { text: 'Cliente', value: 'cliente' },
]
